import { SP } from "./namespace";

/** Public API used by game client (spellbook cards, shop spells, overlays). */
import "./config";
import "./draw";
import "./glyphs";
import "./simulate";
import "./prefs";
import "./tip";
import "./sim";
import "./draft-panel";

window.SpellPreview = SP;

SP.hide = () => {
  SP.hideDraftHover?.();
  SP.Tip?.hide?.();
  SP.SimTip?.hide?.();
};

export function wireSpellPreview(): void {
  SP.wireToggle?.();
  SP.wireSpellbookToolbar?.();
  SP.wire?.();
  SP.wireDraftPanel?.();
}
